module.exports = __webpack_public_path__ + "static/media/office10.34fcd54b.jpg";